const data = {
  h1Tag: "Health Communities by Shyft",
  headerCTAText: "Join the community",
  welcomePrefix: "SHYFT PRESENTS",
  welcomeHeading: "Health Community for Founders",
  welcomeSubheading:
    "A peer group, super focused for founders to keep their health & well-being in check during a super busy work-life.",
  howItWorksTitle: "How it works",
  howItWorks: [
    {
      icon: "icon-community-people-white",
      title:
        "After understanding your lifestyle and interests, we place you in a community of like-minded people going through the same stage of life or business as you.",
    },
    {
      icon: "icon-community-hand-white",
      title:
        "As part of the community, we keep a focus on your nutritional, mental and physical health with motivation & support from the group, curated sessions, meetups and lasting connections!",
    },
  ],
  formData: {
    src: "https://tally.so/embed/3lqLYv?alignLeft=1&transparentBackground=1&dynamicHeight=1&hideTitle=1",
    title: "What's Your Fitness personality?",
  },
};

export default data;
